import { provideConfig } from '@spartacus/core'
import { NgModule } from '@angular/core'
import { FsComponentConverter } from 'fs-spartacus-common'
import { TEASER_WITH_BUBBLES_CONVERTER_TOKEN, TeaserWithBubblesConverter } from './teaser-with-bubbles.component.converter'
import { BUBBLE_CONVERTER_TOKEN, BubbleConverter } from './bubble/bubble.component.converter'

@NgModule({
  providers: [
    provideConfig({
      featureModules: {
        bubbleWrapperFeature: {
          module: () => import('./teaser-with-bubbles.module').then((m) => m.TeaserWithBubblesModule),
          cmsComponents: ['teaserwithbubbles', 'bubble'],
        },
      }
    }),
    {
      provide: TEASER_WITH_BUBBLES_CONVERTER_TOKEN,
      useExisting: TeaserWithBubblesConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        teaserwithbubbles: TEASER_WITH_BUBBLES_CONVERTER_TOKEN
      },
      multi: true
    },
    {
      provide: BUBBLE_CONVERTER_TOKEN,
      useExisting: BubbleConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        bubble: BUBBLE_CONVERTER_TOKEN
      },
      multi: true
    }
  ]
})
export class TeaserWithBubblesFeatureModule {}
